import { render, staticRenderFns } from "./FoodProductionActions.vue?vue&type=template&id=5409575d&scoped=true"
import script from "./FoodProductionActions.vue?vue&type=script&lang=js"
export * from "./FoodProductionActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5409575d",
  null
  
)

export default component.exports